import { OrderPaymentType } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const paymentValidationMessagesResource =
	Resources.base.payment.validationMessages;

export const getAddPaymentFormModelSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) =>
	z.object({
		dateCreated: z
			.string()
			.nonempty({ message: t(paymentValidationMessagesResource.dateCreated) }),
		type: z.nativeEnum(OrderPaymentType),
		amount: z.number().refine((val) => Number.isFinite(val)),
	});

export type AddPaymentFormModel = z.infer<
	ReturnType<typeof getAddPaymentFormModelSchema>
>;
